import React, { useEffect } from 'react'
// ** Dropdowns Imports
import UserDropdown from "./UserDropdown"
// import NotificationDropdown from "./NotificationDropdown"
import { ShoppingCart } from 'react-feather'
import { Badge } from "reactstrap"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

const NavbarUser = () => {
  const stores = useSelector((state) => state.commonreducerSlice)
  const navigate = useNavigate()

  useEffect(() => {
    if (stores.woCates && stores.woCates.length > 0) {
      const woCates = stores.woCates.length > 0 ? stores.woCates : []
      if (woCates.find(find => find.value === 4)) {
        setCategoryId(woCates.find(find => find.value === 4))
        const woTypes = woCates.find(find => find.value === 4).woTypes
        if (woTypes.find(find => find.value === 11)) {
          setTypeId(woTypes.find(find => find.value === 11))
        }
      }
    }
  }, [stores.woCates, stores.woCates.length])

  return (
    <ul className="nav navbar-nav align-items-center right_menu">
      {/* <div className='last-login-wrapper'>
        <div className='last-login-label'>
          Last login date & time:
        </div>
        <div className='last-login-value'>
          {DateTimeConversion(JSON.parse(isUserLoggedIn()).lastLoggedIn)}
        </div>
      </div> */}
      {/* <NavbarCreate /> */}
      <div className='position-relative shopping-cart-icon' onClick={() => {
        navigate('/pageRefresh')
        setTimeout(() => {
          navigate(`/cart`)
        }, 100)
      }}>
        <Badge pill color='primary' className='badge-up'>
          {(stores.cartItems)?.length || 0}
        </Badge>
        <ShoppingCart className='text-primary' size={22} />
      </div>
      {/* <NotificationDropdown /> */}
      <UserDropdown />
    </ul >
  )
}
export default NavbarUser